import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { VehicleConnectionsSection } from '../../../Delivery/Registries/VehicleConnectionsSection';
import { VehicleRelationshipsSection } from '../../../Delivery/Registries/VehicleRelationshipsSection';
export function HoldingsAndConnectedWork({ vehicleId }) {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("section", {
                children: [
                    /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                        variant: "group",
                        title: "Holdings (edit)"
                    }),
                    /*#__PURE__*/ _jsx(VehicleRelationshipsSection, {
                        vehicleId: vehicleId
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("section", {
                children: [
                    /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                        variant: "group",
                        title: "Connected work"
                    }),
                    /*#__PURE__*/ _jsx(VehicleConnectionsSection, {
                        vehicleId: vehicleId,
                        kind: "program"
                    })
                ]
            })
        ]
    });
}
